/* components/patterns/MemberRow.jsx — строка участника команды.
   Аватар/инициалы + имя + email + бейдж роли + действия (Изменить / Исключить).
   Назначенная роль доступа (assigned_role, T3) метится глифом shield: role_name уже
   несёт её имя из адаптера (у админа роль не действует — обычный бейдж статуса).
   На xs/sm — вертикальный стек (не горизонтальный ряд). ХЕНДОФФ → components/settings/. */

import { Pill } from '../ui/Badge.jsx';
import { Button } from '../ui/Button.jsx';
import { Icon } from '../ui/Icon.jsx';

  const ROLE_TONE = { owner: 'accent', admin: 'info', member: 'neutral' };

  function MemberRow({ member, canManage, onEdit, onRevoke }) {
    const hasRole = !!member.assigned_role && !member.is_owner && !member.is_admin;
    const tone = hasRole ? 'info' : (ROLE_TONE[member.role] || 'neutral');
    const protectedRow = member.is_owner; // владельца нельзя исключить/изменить
    return (
      <div className="team-row">
        <span className={'member-avatar member-avatar--' + (member.is_owner ? 'accent' : 'neutral')} aria-hidden="true">
          {member.initials || (member.full_name || '?').slice(0, 1)}
        </span>
        <div className="team-row__id">
          <div className="team-row__name t-label">{member.full_name}</div>
          <div className="team-row__email t-caption text-dim num">{member.email}</div>
        </div>
        <Pill tone={tone} size="sm" glyph={member.is_owner ? 'crown' : (hasRole ? 'shield' : false)}>{member.role_name}</Pill>
        {canManage && !protectedRow && (
          <div className="team-row__actions cluster cluster-4">
            <Button variant="ghost" size="sm" iconLeft="edit" onClick={() => onEdit && onEdit(member)}>Изменить</Button>
            <Button variant="ghost" size="sm" iconLeft="trash" onClick={() => onRevoke && onRevoke(member)}>Исключить</Button>
          </div>
        )}
      </div>
    );
  }

export { MemberRow };
